import dynamic from 'next/dynamic'

export const DynamicGiftCardOrderOverviewModal = dynamic(
  () => import('.').then((mod) => mod.GiftCardOrderOverviewModal),
  { ssr: false },
)
